export const toggleMenu = () => {
  const btnOpenMenu = document.querySelector('.header_fix .burgerMenu a.burger_btn')
  const nav = document.querySelector('.header_fix .burgerMenu nav.burger_menu_sidebar')
  const btnCloseMenu = document.querySelector('.header_fix .burgerMenu ul.topnav a.close_burger_menu')

  // console.log('btnburger')
  if (btnOpenMenu) {
    btnOpenMenu.addEventListener('click', function () {
      event.preventDefault()

      nav.classList.add('show')
    })
  }

  if (btnCloseMenu) {
    btnCloseMenu.addEventListener('click', function () {
      event.preventDefault()

      nav.classList.remove('show')
    })
  }

  const { OverlayScrollbars } = OverlayScrollbarsGlobal

  const menuSidebar = OverlayScrollbars(document.querySelector('.burger_menu_sidebar .scrollbar-wrapper'), {
    scrollbars: {
      theme: 'os-theme-light'
    }
  })
}
